export default {
    path: "/app/:companyId/:appId",
    name: "app",
    meta: {
        title: "主页"
    },
    props: true,
    component: () => import("@/views/app/app.vue"),
    children: [
        {
            path: "workBench/:_key",
            name: "workBench",
            meta: {
                title: "工作台"
            },
            component: () => import("@/views/menu/workBench/workBench.vue"),
            props: true
        },
        {
            path: "sheet/:_key",
            name: "sheet",
            meta: {
                title: "工作表"
            },
            component: () => import("@/views/menu/sheet/sheet.vue"),
            props: true
        },
        {
            path: "sheet/:_key/edit/:_id/:isCreate/:canEdit",
            name: "sheetUpdate",
            meta: {
                title: "工作表编辑"
            },
            component: () => import("@/views/menu/sheet/operation/update/sheetUpdate.vue"),
            props: true
        },
        {
            path: "report/:_key",
            name: "report",
            meta: {
                title: "工作报告"
            },
            component: () => import("@/views/menu/report/report.vue"),
            props: true
        },
        {
            path: "dashboard/:_key",
            name: "dashboard",
            meta: {
                title: "仪表盘"
            },
            component: () => import("@/views/menu/dashboard/dashboard.vue"),
            props: true
        },
        {
            path: "custom/:_key",
            name: "custom",
            meta: {
                title: "定义页"
            },
            component: () => import("@/views/menu/custom/custom.vue"),
            props: true
        },
        {
            path: "embedPage/:_key",
            name: "embedPage",
            meta: {
                title: "嵌入页面"
            },
            component: () => import("@/views/menu/embedPage/embedPage.vue"),
            props: true
        },
        {
            path: "fileDirectory/:_key",
            name: "fileDirectory",
            meta: {
                title: "文档管理"
            },
            component: () => import("@/views/menu/fileDirectory/fileDirectory.vue"),
            props: true
        },

        // 固定放最后两项
        {
            path: "remind",
            name: "remind",
            meta: {
                title: "提醒",
                icon: "bico-Todotask",
                size: 16,
                useBadge: true,
                isRight: true
            },
            component: () => import("@/views/remind/remind.vue"),
            props: true
        },
        {
            path: "userInfo",
            name: "userInfo",
            meta: {
                title: "个人设置",
                icon: "bico-PersonalInformation",
                size: 16,
                isDropdown: true
            },
            component: () => import("@/views/userInfo/userInfo.vue"),
            props: true
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/app.js